<h1 mat-dialog-title>
  {{ 'AgendaExport' | translate}}
</h1>
<div mat-dialog-content>
  <form [formGroup]="exportForm">
    <fieldset [disabled]="isSubmitting">
      <div class="line line-margin">
        <div fxLayout="column" fxLayoutAlign="start">
          <div>
            <h5>{{ 'ExportRange' | translate }}</h5>
          </div>
          <div fxLayout="row" fxLayoutAlign="start">
            <div fxFlex="50">
              <mat-form-field [hintLabel]="'date_format_hint' | translate">
                <mat-label class="required">{{ 'DateFrom' | translate }}</mat-label>
                <input matInput #exportFrom formControlName="exportFrom" [matDatepicker]="pickerDateFrom" autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="pickerDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateFrom startView="year"></mat-datepicker>
                <mat-error *ngIf="f['exportFrom'].errors && f['exportFrom'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="f['exportFrom'].errors && f['exportFrom'].hasError('lessThan')">{{ 'Field_less_than_end' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field [hintLabel]="'date_format_hint' | translate">
                <mat-label class="required">{{ 'DateTo' | translate }}</mat-label>
                <input matInput #exportTo formControlName="exportTo" [matDatepicker]="pickerDateTo" autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="pickerDateTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateTo startView="year"></mat-datepicker>
                <mat-error *ngIf="f['exportTo'].errors && f['exportTo'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="f['exportTo'].errors && f['exportTo'].hasError('greaterThan')">{{ 'Field_more_than_start' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="line line-margin">
        <mat-form-field [hintLabel]="'date_format_hint' | translate">
          <mat-label class="required">{{ 'ImportFrom' | translate }}</mat-label>
          <input matInput #importStartDate formControlName="importStartDate" [matDatepicker]="pickerImportStartDate" autocomplete="off">
          <mat-datepicker-toggle matSuffix [for]="pickerImportStartDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerImportStartDate startView="year" [startAt]="startDate"></mat-datepicker>
          <mat-error *ngIf="f['importStartDate'].errors && f['importStartDate'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="line line-margin">
        <mat-checkbox color="primary" formControlName="deleteTimeSlots">{{ 'deleteTimeSlots' | translate }}</mat-checkbox>
      </div>

      <div class="line line-margin">
        <div class="line line-margin">
          <div fxLayout="column" fxLayoutAlign="start">
            <div>
              <h5>{{ 'Teams' | translate }}</h5>
            </div>
            <div fxLayout="row" fxLayoutAlign="start">
              <div fxFlex="100">

                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <!-- This is for leaf nodes -->
                  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                    <mat-checkbox
                      [checked]="checklistSelection.isSelected(node)"
                      (change)="todoLeafItemSelectionToggle(node)">
                      {{node.item}}
                    </mat-checkbox>
                  </mat-tree-node>

                  <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                  </mat-tree-node>

                  <!-- This is for nodes with children -->
                  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                    <button mat-icon-button matTreeNodeToggle>
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    <mat-checkbox
                      [checked]="descendantsAllSelected(node)"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      (change)="todoItemSelectionToggle(node)">
                      {{node.item}}
                    </mat-checkbox>
                  </mat-tree-node>
                </mat-tree>
                <mat-error *ngIf="!this.checklistValidated">{{ 'Field_required' | translate }}</mat-error>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>
<mat-dialog-actions>

  <button mat-button mat-dialog-close tabindex="-1">
    {{ 'Cancel' | translate}}
  </button>

  <button mat-raised-button (click)="submitForm()" [disabled]="isSubmitting" color="accent">
    {{ 'Export' | translate}}
  </button>

</mat-dialog-actions>
